/* ODD HAND CO. quick add icon */
if (!customElements.get('oh-quick-add')) {
  class OhQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.button = this.querySelector('.oh-qa__button');
      this.panel = this.querySelector('.oh-qa__panel');
      this.status = this.querySelector('.oh-qa__status');

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.dataset.variantId) {
          this.add(this.dataset.variantId, this.dataset.qty);
        } else {
          this.togglePanel();
        }
      });

      if (this.panel) {
        const json = this.panel.querySelector('.oh-qa__variants');
        this.variants = json ? JSON.parse(json.textContent) : null;
        this.selects = Array.from(this.panel.querySelectorAll('.oh-qa__select'));
        this.addButton = this.panel.querySelector('.oh-qa__add');
        this.selects.forEach((select) => {
          select.addEventListener('click', (event) => event.stopPropagation());
          select.addEventListener('change', () => this.updateSelected());
        });
        if (this.variants) this.updateSelected();

        this.panel.addEventListener('click', (event) => {
          if (event.target.closest('.oh-qa__select')) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.target.closest('.oh-qa__add')) {
            if (!this.selected || !this.selected.available) return;
            this.togglePanel(false);
            this.add(this.selected.id, this.selected.qty);
            return;
          }
          const option = event.target.closest('.oh-qa__option');
          if (!option || option.disabled) return;
          this.togglePanel(false);
          this.add(option.dataset.variantId, option.dataset.qty);
        });
        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.togglePanel(false);
        };
        this.onKey = (event) => {
          if (event.key === 'Escape') {
            this.togglePanel(false);
            this.button.focus();
          }
        };
      }
    }

    updateSelected() {
      const values = this.selects.map((select) => select.value);
      this.selected = this.variants.find((variant) =>
        values.every((value, index) => variant.options[index] === value)
      );
      if (!this.addButton) return;
      if (!this.selected) {
        this.addButton.disabled = true;
        this.addButton.textContent = 'Unavailable';
      } else if (!this.selected.available) {
        this.addButton.disabled = true;
        this.addButton.textContent = 'Sold out';
      } else {
        this.addButton.disabled = false;
        this.addButton.textContent = 'Add to cart';
      }
    }

    togglePanel(force) {
      if (!this.panel) return;
      const open = typeof force === 'boolean' ? force : this.panel.hidden;
      this.panel.hidden = !open;
      this.button.setAttribute('aria-expanded', String(open));
      if (open) {
        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onKey);
        const first = this.panel.querySelector('.oh-qa__option:not([disabled]), .oh-qa__select');
        if (first) first.focus({ preventScroll: true });
      } else {
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }
    }

    getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    async add(variantId, qty) {
      if (this.classList.contains('is-loading')) return;
      this.classList.remove('is-added', 'is-error');
      this.classList.add('is-loading');
      this.setStatus('Adding to cart');

      const cart = this.getCart();
      const body = { id: Number(variantId), quantity: Number(qty) || 1 };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.button);
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          this.fail(data.description || data.message || 'Could not add to cart');
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'oh-quick-add',
            productVariantId: variantId,
            cartData: data,
          });
        }

        this.classList.remove('is-loading');
        this.classList.add('is-added');
        this.setStatus('Added to cart');
        setTimeout(() => this.classList.remove('is-added'), 700);
        if (document.getElementById('opus-shadow-container')) return; // Opus opens its own cart drawer; also opening the theme drawer left the page scroll-locked on mobile

        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || `${root}cart`;
        }
      } catch (error) {
        console.error(error);
        this.fail('Could not add to cart');
      }
    }

    fail(message) {
      this.classList.remove('is-loading');
      this.classList.add('is-error');
      this.setStatus(message);
      this.button.title = message;
      setTimeout(() => {
        this.classList.remove('is-error');
        this.button.removeAttribute('title');
      }, 2500);
    }

    setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('oh-quick-add', OhQuickAdd);
}
